document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  document.querySelectorAll('.pc-store-dropdown[open], .pc-store-mobile-menu[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
  const menu = event.target.closest('.pc-store-dropdown[open], .pc-store-mobile-menu[open]');
  if (menu) {
    menu.open = false;
    menu.querySelector('summary')?.focus();
    event.preventDefault();
  }
});

document.addEventListener('toggle', (event) => {
  const menu = event.target;
  if (!(menu instanceof HTMLDetailsElement) || !menu.open || !menu.classList.contains('pc-store-dropdown')) return;
  menu.parentElement.querySelectorAll('.pc-store-dropdown[open]').forEach((other) => {
    if (other !== menu) other.open = false;
  });
}, true);
